import axios from "axios";
import { LegacyReportParameter, LegacyReportResult } from "./types";

export const getReports = async () => {
  const { data } = await axios.get<string[]>("/api/reporting/reports");
  return data;
};

export const getReportParameters = async (reportName: string) => {
  const { data } = await axios.get<LegacyReportParameter[]>(
    `/api/reporting/reports/${encodeURIComponent(reportName)}/parameters`
  );
  return data;
};

export const runReport = async (reportName: string, parameters: Record<string, string>) => {
  const { data } = await axios.post<LegacyReportResult>("/api/reporting/run", {
    reportName,
    parameters
  });
  return data;
};
